/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ points: NonNullable<unknown> }} Leading_ByInputs */

const th_leading_by = /** @type {(inputs: Leading_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`นำอยู่ ${i?.points} แต้ม`)
};

const en_leading_by = /** @type {(inputs: Leading_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Leading by ${i?.points}`)
};

const ja_leading_by = /** @type {(inputs: Leading_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.points}点リード`)
};

const zh_leading_by = /** @type {(inputs: Leading_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`领先 ${i?.points} 分`)
};

const es_leading_by = /** @type {(inputs: Leading_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gana por ${i?.points}`)
};

const pt_leading_by = /** @type {(inputs: Leading_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vencendo por ${i?.points}`)
};

const id_leading_by = /** @type {(inputs: Leading_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unggul ${i?.points}`)
};

const fr_leading_by = /** @type {(inputs: Leading_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mène de ${i?.points}`)
};

const tl_leading_by = /** @type {(inputs: Leading_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nangunguna nang ${i?.points}`)
};

const vi_leading_by = /** @type {(inputs: Leading_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dẫn ${i?.points}`)
};

const ko_leading_by = /** @type {(inputs: Leading_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.points}점 차 리드`)
};

const de_leading_by = /** @type {(inputs: Leading_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Führt mit ${i?.points}`)
};

const ru_leading_by = /** @type {(inputs: Leading_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ведёт в ${i?.points}`)
};

const tr_leading_by = /** @type {(inputs: Leading_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.points} sayı önde`)
};

const it_leading_by = /** @type {(inputs: Leading_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Avanti di ${i?.points}`)
};

const pl_leading_by = /** @type {(inputs: Leading_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prowadzi ${i?.points} pkt`)
};

const uk_leading_by = /** @type {(inputs: Leading_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Веде на ${i?.points}`)
};

const hi_leading_by = /** @type {(inputs: Leading_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.points} अंकों से आगे`)
};

const ar_leading_by = /** @type {(inputs: Leading_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`يتقدّم بـ ${i?.points}`)
};

const ms_leading_by = /** @type {(inputs: Leading_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mendahului ${i?.points}`)
};

const bn_leading_by = /** @type {(inputs: Leading_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.points} পয়েন্টে এগিয়ে`)
};

const zh_tw2_leading_by = /** @type {(inputs: Leading_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`領先 ${i?.points} 分`)
};

const zh_hk2_leading_by = /** @type {(inputs: Leading_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`領先 ${i?.points} 分`)
};

const ur_leading_by = /** @type {(inputs: Leading_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.points} سے آگے`)
};

const fa_leading_by = /** @type {(inputs: Leading_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.points} امتیاز جلوتر`)
};

const sw_leading_by = /** @type {(inputs: Leading_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Anaongoza kwa ${i?.points}`)
};

const nl_leading_by = /** @type {(inputs: Leading_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voor met ${i?.points}`)
};

/**
* | output |
* | --- |
* | "Leading by {points}" |
*
* @param {Leading_ByInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const leading_by = /** @type {((inputs: Leading_ByInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leading_ByInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_leading_by(inputs)
	if (locale === "ja") return ja_leading_by(inputs)
	if (locale === "zh") return zh_leading_by(inputs)
	if (locale === "es") return es_leading_by(inputs)
	if (locale === "pt") return pt_leading_by(inputs)
	if (locale === "id") return id_leading_by(inputs)
	if (locale === "fr") return fr_leading_by(inputs)
	if (locale === "tl") return tl_leading_by(inputs)
	if (locale === "vi") return vi_leading_by(inputs)
	if (locale === "ko") return ko_leading_by(inputs)
	if (locale === "de") return de_leading_by(inputs)
	if (locale === "ru") return ru_leading_by(inputs)
	if (locale === "tr") return tr_leading_by(inputs)
	if (locale === "it") return it_leading_by(inputs)
	if (locale === "pl") return pl_leading_by(inputs)
	if (locale === "uk") return uk_leading_by(inputs)
	if (locale === "hi") return hi_leading_by(inputs)
	if (locale === "ar") return ar_leading_by(inputs)
	if (locale === "ms") return ms_leading_by(inputs)
	if (locale === "bn") return bn_leading_by(inputs)
	if (locale === "zh-TW") return zh_tw2_leading_by(inputs)
	if (locale === "zh-HK") return zh_hk2_leading_by(inputs)
	if (locale === "ur") return ur_leading_by(inputs)
	if (locale === "fa") return fa_leading_by(inputs)
	if (locale === "sw") return sw_leading_by(inputs)
	if (locale === "nl") return nl_leading_by(inputs)
	return en_leading_by(inputs)
});